'use client'

import AnimatedSection from '@/components/AnimatedSection'
import CustomDevelopment from './_blocks/CustomDevelopment'
import ITSupport from './_blocks/ITSupport'
import CtaBannerCentered from './_blocks/CtaBannerCentered'
import Industries from './_blocks/Industries'
import Instrument from './_blocks/Instrument'
import Clients from './_blocks/Clients'
import Contact from '@/app/_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

export default function ServicesContent() {
	return (
		<>
			<CustomDevelopment />
			<ITSupport />
			<AnimatedSection animation="slideUp">
				<div className={styles.ctaBannerBlock}>
					<CtaBannerCentered />
				</div>
			</AnimatedSection>
			<Industries />
			<Instrument />
			<Clients />
			<AnimatedSection animation="slideUp">
				<div className={styles.contactBlock}>
					<Contact />
				</div>
			</AnimatedSection>
		</>
	)
}
